import { normalizeCharacters } from "@/utils";
import {
  byValue,
  actividades,
  ocupaciones,
  provincias,
  situacionesLaborales
} from "@/config/constants";

export default {
  /**
   * Obtener la ruta actual del state
   */
  getTcode: state => () => state.tcode,
  getRoute: state => () => state.route,
  getConsulta: state => () => state.consulta,
  getConsultaHipotecario: state => () => state.consultaHipotecario,
  getConsultaPayload: state => () => state.consultaPayload,
  getRenaperCalled: state => () => state.renaperCalled,
  getConfirmarRenaper: state => () => state.confirmarRenaper,
  getSimulacion: state => () => state.simulacion,
  esCliente: state => () => state.esCliente,
  getOferta: state => () => state.oferta,
  getPaso1: state => () => state.paso1,
  getPaso2: state => () => state.paso2,
  getPaso3: state => () => state.paso3,
  getPaso4: state => () => state.paso4,
  getPaso5: state => () => state.paso5,
  getEntrega: state => () => state.entrega,
  getResumen: state => () => state.resumen,
  getPaso6: state => () => state.paso6,
  getPaso7: state => () => state.paso7,
  getPaso8: state => () => state.paso8,
  getEnvioSms: state => () => state.envioSms,
  getRandomKey: state => () => state.simulacion.randomKey,
  getContractsPdf: state => () => state.dataVeridas.contracts,
  getDeviceUdid: state => () => state.paso7.deviceUdid,
  getKeyLoginVeridas: state => () => state.dataVeridas.key,
  getCircuito: state => () => state.circuito,
  getNumeroTramite: state => () => state.entrega.numeroTramite,
  getResultVeridas: state => () => state.dataVeridas.response,
  getIsBiometria: state => () => state.dataVeridas.thanksVeridas,
  getAdobeTargetExperience: state => () => state.adobeTargetExperience,
  getErrorVeridas: state => () => state.errorVeridas,
  getError: state => () => state.error,
  getSucursales: state => () =>
    state.sucursales.sort((a, b) => a.distance - b.distance),
  getContadorLlamadosMerlin: state => () => state.contadorLlamadosMerlin,
  getIsBTD3: state => () => state.isBTD3,
  getCelularNormalizado: state => () => state.consulta.celular.normalizado,
  getCelular: state => () => state.consulta.celular,
  getConfirmacionDataVeridas: state => () => {
    let situacionLaboral = byValue(
      state.paso2.situacionLaboral,
      situacionesLaborales
    );
    let actividad = byValue(state.paso2.actividad, actividades);
    let ocupacion = byValue(state.paso2.ocupacion, ocupaciones);
    let domParticularProvincia = byValue(
      state.paso1.domicilioParticular.provincia,
      provincias
    );
    let domOtroProvincia = byValue(
      state.entrega.otroDomicilio.provincia,
      provincias
    );
    let { area, caracteristica, nro } = state.consulta.celular.normalizado;
    return {
      cliente: {
        emailContacto: state.consulta.email,
        telContacto: {
          area,
          caracteristica,
          nro,
          interno: ""
        },
        lugarNacimiento: normalizeCharacters(state.paso1.lugarNacimiento),
        cuil: state.paso1.cuil,
        estadoCivil: state.paso1.estadoCivil,
        conyuge: {
          tipoDocumento: state.paso1.conyuge.tipoDocumento,
          numeroDocumento: state.paso1.conyuge.numeroDoc,
          apellido: normalizeCharacters(state.paso1.conyuge.apellido),
          nombre: normalizeCharacters(state.paso1.conyuge.nombre),
          nacionalidad: ""
        },
        domicilio: {
          calle: normalizeCharacters(state.paso1.domicilioParticular.calle),
          numero: normalizeCharacters(state.paso1.domicilioParticular.numero),
          piso: normalizeCharacters(state.paso1.domicilioParticular.piso),
          depto: normalizeCharacters(state.paso1.domicilioParticular.dpto),
          codigoPostal: state.paso1.domicilioParticular.codigoPostal,
          localidad: normalizeCharacters(
            state.paso1.domicilioParticular.localidad
          ),
          codProvincia: domParticularProvincia.value,
          referencia: ""
        },
        domAlternativo: {
          calle: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? state.entrega.otroDomicilio.calle
              : state.paso1.domicilioParticular.calle
          ),
          numero: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? state.entrega.otroDomicilio.numero
              : state.paso1.domicilioParticular.numero
          ),
          piso: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? state.entrega.otroDomicilio.piso
              : state.paso1.domicilioParticular.piso
          ),
          depto: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? state.entrega.otroDomicilio.dpto
              : state.paso1.domicilioParticular.dpto
          ),
          codigoPostal: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? state.entrega.otroDomicilio.codigoPostal
              : state.paso1.domicilioParticular.codigoPostal
          ),
          localidad: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? state.entrega.otroDomicilio.localidad
              : state.paso1.domicilioParticular.localidad
          ),
          codProvincia: normalizeCharacters(
            state.entrega.selectDomicilio === "otro"
              ? domOtroProvincia.value
              : domParticularProvincia.value
          ),
          referencia: ""
        },
        situacionLaboral: situacionLaboral.value,
        tipoActividad: actividad.value,
        tipoOcupacion: ocupacion.value,
        ingresos: state.paso2.ingresoNeto,
        marcaPEP: !!Number(state.paso3.pep),
        marcaSujetoObligado: !!Number(state.paso3.sujetoObligado),
        constanciaSujetoObligado: false,
        actividadSujetoObligado: state.paso3.actividadSujetoObligado,
        eResumen: true
      },
      producto: {
        solicitudSucursal: state.entrega.sucursal
          ? (state.entrega.sucursal + "").padStart(4, "0")
          : "0999"
      },
      randomKey: state.simulacion.randomKey,
      verificationProcessId: state.DVSIframeData.id,
      deviceId: state.deviceId,
      deviceIdTimestamp: state.deviceIdTimestamp
    };
  },
  getDeviceId: state => () => state.deviceId,
  getDeviceIdTimestamp: state => () => state.deviceIdTimestamp,
  getFechaSistema: state => () => state.fechaSistema,
  getCotizacion: state => () => state.cotizacion,
  getDataAuthASO: state => () => state.dataAuthASO,
  getDVSIframeData: state => () => state.DVSIframeData,
  getPrescriptor: state => () => state.precriptor,
  getLandingQrUrl: state => () => state.landingQrUrl
};
